module.exports = "<div class=\"page\">\n  <div class=\"page-content w-100 mw-900 shadow no-p\">\n    <div class=\"form-header p-2\">\n      <h2>Comercio</h2>\n    </div>\n    <app-commerce-general-form [showLogin]=\"false\"></app-commerce-general-form>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/commerce-page/commerce-page.component.html
// module id = 1151
// module chunks = 0